import styled from 'styled-components'

import { COLOURS } from 'resources'

// Generated using input range slider CSS style generator (version 20211225)
// https://toughengineer.github.io/demo/slider-styler
const InputRangeSlider = styled.input.attrs(({ min, max, value }) => ({
  style: {
    '--min': min ?? 1,
    '--max': max ?? 0,
    '--value': value ?? 0,
    '--range': `calc(${max ?? 0} - ${min ?? 1})`,
    '--ratio': `calc((${value ?? 0} - ${min ?? 1}) / var(--range))`,
    '--sx': `calc(0.5 * 12px + var(--ratio) * (100% - 12px))`,
  },
}))`
  /* stylelint-disable -- Imported CSS with polyfill for different vendor prefixes */
  --primary-color: ${COLOURS.secondaryPurple1};
  --secondary-color: ${COLOURS.secondaryPurple2};
  --size: ${({ size }) => size || 0};
  --thumb-size: calc(var(--size) * 4px + 12px);
  --track-height: calc(var(--size) * 4px + 4px);

  height: var(--thumb-size);
  width: 100%;
  -webkit-appearance: none;

  &:focus {
    outline: none;
  }

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    --primary-color: ${COLOURS.neutralGrey4};
    --secondary-color: ${COLOURS.neutralGrey3};

    &:hover {
      cursor: not-allowed;
    }
  }

  /* Webkit styles */
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: var(--thumb-size);
    height: var(--thumb-size);
    border-radius: calc(var(--thumb-size) * 0.5);
    margin-top: calc(var(--track-height) * 0.5 - var(--thumb-size) * 0.5);
    background: var(--primary-color);
    border: none;
  }

  &::-webkit-slider-runnable-track {
    height: var(--track-height);
    border: none;
    border-radius: calc(var(--track-height) * 0.5);
    background: linear-gradient(var(--primary-color), var(--primary-color)) 0 / var(--sx) 100% no-repeat,
      var(--secondary-color);
    box-shadow: none;
  }

  &::-webkit-slider-thumb:active {
    box-shadow: 0 0 2px var(--primary-color);
  }

  /* Mozilla */
  &::-moz-range-thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    border-radius: calc(var(--thumb-size) * 0.5);
    background: var(--primary-color);
    border: none;
    box-shadow: 0 0 2px ${COLOURS.neutralBlack};
  }

  &::-moz-range-track {
    height: var(--track-height);
    border: none;
    border-radius: calc(var(--track-height) * 0.5);
    background: linear-gradient(var(--primary-color), var(--primary-color)) 0 / var(--sx) 100% no-repeat,
      var(--secondary-color);
    box-shadow: none;
  }

  &::-moz-range-thumb:active {
    box-shadow: 0 0 2px ${COLOURS.secondaryPurple1};
  }

  /* MS */
  &::-ms-fill-upper {
    background: transparent;
    border-color: transparent;
  }

  &::-ms-fill-lower {
    height: var(--track-height);
    border-radius: calc(var(--track-height) * 0.5) 0 0 calc(var(--track-height) * 0.5);
    margin: -undefined 0 -undefined -undefined;
    background: var(--primary-color);
    border: none;
    border-right-width: 0;
  }

  &::-ms-thumb {
    width: var(--thumb-size);
    height: var(--thumb-size);
    border-radius: calc(var(--thumb-size) * 0.5);
    background: var(--primary-color);
    border: none;
    box-shadow: 0 0 2px ${COLOURS.neutralBlack};
    margin-top: 0;
    box-sizing: border-box;
  }

  &::-ms-track {
    height: var(--track-height);
    border-radius: calc(var(--track-height) * 0.5);
    background: var(--secondary-color);
    border: none;
    box-shadow: none;
    box-sizing: border-box;
  }

  &::-ms-thumb:active {
    box-shadow: 0 0 2px ${COLOURS.secondaryPurple1};
  }
`

export default InputRangeSlider
